module.exports = __webpack_public_path__ + "img/icon_l_gb.29cf13b6.png";